if (!customElements.get('shop-look')) {
  customElements.define(
    'shop-look',
    class shopLook extends HTMLElement {
      constructor() {
        super();
        this.buttons = [...this.querySelectorAll('.shop-the-look__hotspot')];
        this.buttons.forEach((button) => button.addEventListener('click', this.updateActiveItem.bind(this)));
      }

      updateActiveItem(e) {
        const targetId = e.target.dataset.id;
        const currentActive = this.querySelector('.shop-the-look__hotspot.is-active');
        if (!currentActive) return;

        if (currentActive.dataset.id == targetId) return;

        // update button
        currentActive.classList.remove('is-active');
        e.target.classList.add('is-active');

        //update active product
        const currentProduct = this.querySelector('.active__inspoitem');
        const newProduct = this.querySelector(`#${targetId}`);
        if (!currentProduct || !newProduct) return;

        currentProduct.classList.remove('active__inspoitem');
        newProduct.classList.add('active__inspoitem');
      }
    }
  );
}
